import { FormTab, Record, required, TabbedForm } from "react-admin";
import { VirtualTenantDto } from "../../../common/data/service-proxies";
import { RaTenantPicker } from "../../common/form/RaTenantPicker";
import { VehicleSelectionGrid } from "./VehicleSelectionGrid";
import { FormToolbar } from "../../common/form/FormToolbar";
import { UsersSelectionForm } from "./UsersSelectionForm";
import { DriverSelectionGrid } from "./DriverSelectionGrid";

interface Props {
  record?: VirtualTenantDto & Record;
  isEdit?: boolean;
}

export const VirtualTenantForm = ({ isEdit, ...props }: Props) => {
  return (
    <TabbedForm
      variant="outlined"
      className="form-create-edit"
      {...props}
      toolbar={<FormToolbar alwaysEnableSaveButton />}
    >
      <FormTab label="Customer">
        <RaTenantPicker
          disabled={isEdit}
          label="Customer to use"
          source="tenantId"
          validate={[required()]}
        />
      </FormTab>
      <FormTab label="Users">
        <UsersSelectionForm />
      </FormTab>
      <FormTab label="Vehicles">
        <VehicleSelectionGrid />
      </FormTab>
      <FormTab label="Drivers">
        <DriverSelectionGrid />
      </FormTab>
    </TabbedForm>
  );
};
